export const selectContractsList = (state) => state.invoicing.contractsList;
export const selectContractDetails = (state) => state.invoicing.contractDetails;
export const selectSelectedContract = (state) =>
  state.invoicing.selectedContract;
export const selectUnconfirmedContract = (state) =>
  state.invoicing.contractToConfirm;
export const selectOrderlineEndDateEdit = (state) =>
  state.invoicing.orderlineEndDateEdit;
export const selectOrderlineInvoiceDateEdit = (state) =>
  state.invoicing.orderlineInvoiceDateEdit;
export const selectPastInvoices = (state) => state.invoicing.pastInvoices;
export const selectNewInvoices = (state) => state.invoicing.newInvoices;
export const selectOrderlineInvoiceTwid = (state) =>
  state.invoicing.invoiceTwidEdit;
export const selectInvoiceDetails = (state) => state.invoicing.invoiceDetails;
